module.exports = __webpack_public_path__ + "img/repackService.20478fc7.svg";